// extracted by mini-css-extract-plugin
export var chevron = "_jx-3";
export var chevronRotated = "_jx-4";
export var image = "_jx-1";
export var imageContainer = "_jx-0";
export var shippingAddress = "_jx-2";